import React from 'react'
import PropTypes from 'prop-types'
import produce from 'immer'
import { withFormContext } from 'components/Form'
import { calculatePrice } from 'tools/product'

const stateReducer = (values) => produce(
  (draftState) => {
    draftState.selectedVariantId = values.selectedVariant || (draftState.productState.variants[0] || {}).id
    draftState.totalPrice = calculatePrice(draftState.productState, values, draftState.subItemVariantsKey)
    draftState.totalQuantity = values.totalQuantity
    // values is being used for detected changes only
    draftState.values = values
  }
)

class ProductState extends React.PureComponent {
  static propTypes = {
    product: PropTypes.object.isRequired,
    form: PropTypes.shape({
      values: PropTypes.object,
      setFieldError: PropTypes.func.isRequired
    }).isRequired, // injected by form context
    subItemVariantsKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onMount: PropTypes.func.isRequired
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    if (prevState.values !== nextProps.form.values) {
      return stateReducer(nextProps.form.values)(prevState)
    }
    return null
  }

  constructor (props) {
    super(props)
    this.state = stateReducer(props.form.values)({
      product: props.product,
      productState: props.product,
      calculateVariantDiff: this.calculateVariantDiff,
      calculateOptionDiff: this.calculateOptionDiff,
      totalQuantity: null,
      totalPrice: null,
      selectedVariantId: null,
      values: null,
      subItemVariantsKey: props.subItemVariantsKey
    })
  }

  calculateVariantDiff = (variantId) => {
    const values = produce((draftState) => {
      draftState.selectedVariant = variantId
    })(this.props.form.values)
    const { totalPrice } = stateReducer(values)(this.state)
    return totalPrice - this.state.totalPrice
  }

  calculateOptionDiff = (optionId, subVariantId) => {
    const values = produce((draftState) => {
      if (draftState.subitems === undefined) draftState.subitems = {}
      if (draftState.subitems[optionId] === undefined) draftState.subitems[optionId] = {}
      draftState.subitems[optionId][subVariantId] = (draftState.subitems[optionId][subVariantId] || 0) + 1
    })(this.props.form.values)
    const { totalPrice } = stateReducer(values)(this.state)
    return totalPrice - this.state.totalPrice
  }

  componentDidUpdate (prevProps, prevState) {
    const { form, onChange } = this.props
    const { selectedVariantId } = this.state
    if (prevState.selectedVariantId !== selectedVariantId) {
      form.setFieldError('variantInvalid', false)
    }

    if (prevState !== this.state && typeof onChange === 'function') {
      onChange(prevState, this.state)
    }
  }

  componentDidMount () {
    const { onMount } = this.props
    if (typeof onMount === 'function') {
      onMount(this.state)
    }
  }

  render () {
    const { children } = this.props
    return children(this.state)
  }
}

export default withFormContext(ProductState)
